import { render, staticRenderFns } from "./MyRecommender.vue?vue&type=template&id=02cba26b&scoped=true&"
import script from "./MyRecommender.vue?vue&type=script&lang=js&"
export * from "./MyRecommender.vue?vue&type=script&lang=js&"
import style0 from "./MyRecommender.vue?vue&type=style&index=0&id=02cba26b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cba26b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
